<template>
    <!--    服务信息-->
    <div class="service-information">
        <OrderCaption title="服务信息" :capIcon="capIcon" />
        <div class="information-container">
            <Chunk title="订单名称">
                <template v-slot:context>
                    <div class="chunk_title">{{infos.name}}</div>
                </template>
            </Chunk>

            <Chunk title="订单金额"  v-if="orderStatus != 0">
                <template v-slot:context>
                    <div class="chunk_money">
                        <span class="number">
                            {{infos.money}}
                            <span v-if="infos.money" class="unit">元</span>
                        </span>
                        <span v-if="origin == 2" @click="goWorkstationHome" class="tips">
                            <span>加入工作室您的收益将会更多哟</span>
                            <Icon color="#F84025" name="arrow"/>
                        </span>
                    </div>
                </template>
            </Chunk>

            <Chunk v-if="isServiceOrder" title="订单编号" :desc="infos.orderNo"/>

            <Chunk title="服务时间" :desc="infos.time | timeToMinute"></Chunk>

            <Chunk v-if="infos.cycle" title="服务周期" :desc="`${infos.cycle}天`"/>

            <Chunk title="服务地点" :desc="infos.location" limit></Chunk>

            <Chunk title="服务详情" vertical="flex-start">
                <template v-slot:context>
                    <ul class="chunk_list">
                        <li @click="checkDetail(item)" class="service_item" v-for="(item, index) in infos.details"
                            :key="index">
                            <span class="service_name">{{ item.name }}</span>
                            <Icon class="arrow" color="#222222" name="arrow"/>
                            <component v-if="index === 0"
                                       v-bind:is="origin == 2 ? BubbleTip : BubbleSolid"></component>
                        </li>
                    </ul>
                </template>
            </Chunk>

            <Chunk title="服务所需技能标签" :desc="infos.skillsLabel" limit></Chunk>

        </div>
        <ServiceDetails
            :show="showDetail"
            title="服务详情"
            :infos="normsInfos"
            @clickClose="close"></ServiceDetails>
    </div>
</template>
<script>
    import {Icon} from 'vant';
    import OrderCaption from '@/components/OrderCaption/OrderCaption.vue'
    import Chunk from '@/components/Chunk/Chunk.vue'
    import BubbleTip from '@/components/BubbleTip/BubbleTip.vue'
    import BubbleSolid from '@/components/BubbleTip/BubbleSolid.vue'
    import ServiceDetails from '@/components/ServiceDetails/ServiceDetails.vue'
    import Moment from 'moment'
    import { gotoNative, dataBuryingPoint } from '@/utils/JSBridge.js'
    import findIcon from './img/icon_1.png';
    import studioIcon from './img/icon_2.png';

    export default {
        props: {
            origin: String,
            orderSource: Number,
            orderStatus: String,
            infos: {
                type: Object,
                default: () => ({
                    name: '', // 订单名称
                    money: '', // 订单金额
                    time: '', // 服务时间
                    cycle: '', // 服务周期
                    location: '', // 服务地点
                    details: [], // 服务详情
                    skillsLabel: '', // 技能标签
                    serviceSeniority: '', // 服务年资
                })
            },
            // 服务订单
            isServiceOrder: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            capIcon() {
                return this.origin === '1' ? studioIcon : findIcon;
            }
        },
        data() {
            return {
                BubbleTip: 'BubbleTip',
                BubbleSolid: 'BubbleSolid',
                showDetail: false,
                normsInfos: {},
            }
        },
        filters: {
            timeToMinute(time) {
                return time ? Moment(time).format('YYYY-MM-DD HH:mm') : '';
            }
        },
        methods: {
            checkDetail(item) {
                this.showDetail = true;
                this.normsInfos = item;
                dataBuryingPoint('C000004', 'C000004-003', {id: PAGE_PARAMS.orderNo, orderSource: this.orderSource});
            },
            close() {
                this.showDetail = false;
                this.normsInfos = {}
            },
            goWorkstationHome() {
                dataBuryingPoint('C000004', 'C000004-002', {orderSource: this.orderSource});
                setTimeout(() => {
                    gotoNative('nurse://workstation.home');
                }, 300);
            }
        },
        components: {Icon, OrderCaption, Chunk, BubbleTip, BubbleSolid, ServiceDetails}
    }
</script>
<style lang="scss" scoped>
    .service-information {
        .information-title {
            display: flex;
            align-items: center;
            padding: 20px 16px;
            font-size: 17px;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);

            .title_icon {
                width: 16px;
                margin-right: 10px;
            }
        }

        .information-container {
            padding: 0 16px;

            .chunk_title {
                font-size: 17px;
                font-weight: 500;
                color: rgba(34, 34, 34, 1);
            }

            .chunk_money {
                display: flex;
                align-items: center;

                .number {
                    font-size: 17px;
                    font-weight: bold;
                    color: rgba(250, 87, 65, 1);

                    .unit {
                        font-size: 9px;
                        font-weight: 400;
                        color: rgba(250, 87, 65, 1);
                        margin-right: 8px;
                    }
                }


                .tips {
                    margin-left: 5px;
                    height: 20px;
                    font-size: 10px;
                    font-weight: 400;
                    color: rgba(248, 64, 37, 1);
                    padding: 0 6px;
                    display: inline-flex;
                    align-items: center;
                    border: 1px solid #F84025;
                }
            }

            .chunk_list {
                & > li {
                    display: flex;
                    align-items: center;
                    font-size: 15px;
                    font-weight: 400;
                    color: rgba(34, 34, 34, 1);
                    margin-bottom: 26px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .arrow {
                        margin-left: 3px;
                    }
                }
            }
        }
    }
</style>
